import { Chat as ChatType } from "@/types/chat"
import { Itinerary, ItineraryEvent } from "@/types/itinerary"
import { Trip } from "@/types/trip"

import { ChatApi } from "@/lib/chat-api"
import { itineraryApi } from "./storage/api/itinerary-api"
import { populateTripCache } from "./storage/api/trips-api"
import { updateEventsInCache } from "./storage/itinerary-cache-utils"
import { AppDispatch } from "./storage/redux-store"
import tripSlice from "./storage/trip-slice"

export function updateChatOnCreateOrUpdateItineraryEvent(
  dispatch: AppDispatch,
  response: { itinerary?: Itinerary; event: ItineraryEvent; trip?: Trip }
) {
  const tripRef = response.trip?.ref

  if (response.trip) {
    void populateTripCache(dispatch, response.trip)
    dispatch(tripSlice.actions.setTripRef(response.trip.ref))
  }

  if (tripRef) {
    if (response.itinerary) {
      dispatch(
        itineraryApi.util.updateQueryData(
          "getItinerary",
          { tripRef },
          () => response.itinerary
        )
      )
    }

    if (response.event) {
      updateEventsInCache(dispatch, tripRef, [response.event])
    }
  }
}

// For /chat/new, we create a new chat.
// Bare /chat is handled in initChatPage (mobile Home or desktop new chat).
// For /chat/[chat_id] we fetch the chat with that id.
// Embedded callers still use "latest" below when no id is provided.
export async function fetchChat(
  chatId: "new" | "latest" | number,
  chatApi: ChatApi
): Promise<ChatType> {
  if (chatId === "new") {
    // handle new chat
    return (await chatApi.createChat()).chat
  } else if (chatId !== "latest") {
    // handle chat with id
    try {
      return await chatApi.fetchChat(chatId)
    } catch (e) {
      console.error("Failed to fetch chat", e)
    }
  }

  // url was /chat/latest or /chat/[chat_id] didn't return a chat
  return await chatApi.fetchChat("latest")
}

export let chatViewportInset = 0

export function setChatViewportInset(inset: number) {
  chatViewportInset = inset
}
